import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SVG = styled.svg`
  fill: currentColor;
`;

const SvgContainer = ({ className, children, width, height, viewBox = '0 0 24 24', ...rest }) => (
  <SVG
    className={className}
    width={width || '24px'}
    height={height || '24px'}
    viewBox={viewBox}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    {children}
  </SVG>
);

SvgContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  width: PropTypes.number,
  height: PropTypes.number,
  viewBox: PropTypes.number,
};

const DropdownSearch = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 4C8.65685 4 10 5.34315 10 7C10 8.65685 8.65685 10 7 10C5.34315 10 4 8.65685 4 7C4 5.34315 5.34315 4 7 4ZM7 2C9.76142 2 12 4.23858 12 7C12 8.01985 11.6947 8.96838 11.1704 9.75917L13.2932 11.8819C13.6837 12.2724 13.6837 12.9056 13.2932 13.2961C12.9026 13.6866 12.2695 13.6866 11.8789 13.2961L9.75561 11.1728C8.96554 11.6956 8.01832 12 7 12C4.23858 12 2 9.76142 2 7C2 4.23858 4.23858 2 7 2Z"
      fill="black"
    />
  </svg>
);

const Article = ({ ...props }) => (
  <SvgContainer {...props} viewBox="0 0 14 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0406328 1.59693C0.0139911 1.72713 0 1.86193 0 2V14C0 15.1046 0.895431 16 2 16H12C13.1046 16 14 15.1046 14 14V2C14 0.895431 13.1046 0 12 0H2C1.0335 0 0.227125 0.685564 0.0406328 1.59693ZM2 2H12V14H2V2ZM6 6H4V4H6V6ZM7 6H10V5H7V6ZM10 7V8H4V7H10ZM10 10V9H4V10H10ZM8 11V12H4V11H8Z"
      fill="#37B982"
    />
  </SvgContainer>
);

const CloseDark = ({ ...props }) => (
  <SvgContainer {...props}>
    <path d="M9 11.121l-6.44 6.44-2.12-2.122L6.878 9 .439 2.56 2.561.44 9 6.878l6.44-6.44 2.12 2.122L11.122 9l6.44 6.44-2.122 2.12L9 11.122z" />
  </SvgContainer>
);

const FullSizeLarge = ({ ...props }) => (
  <SvgContainer {...props}>
    <path
      fill="#FFF"
      d="M11.212 14.788c.326.162.326.812 0 1.137l-8.45 8.45h6.175c.488 0 .813.325.813.813 0 .487-.325.812-.813.812H.813C.325 26 0 25.675 0 25.187v-8.125c0-.487.325-.812.813-.812.487 0 .812.325.812.813v6.175l8.288-8.288c.325-.325.974-.325 1.3-.162zM25.188 0c.487 0 .812.325.812.813v8.124c0 .488-.325.813-.813.813-.487 0-.812-.325-.812-.813V2.763l-8.288 8.45c-.139.14-.397.16-.57.163h-.08c-.162 0-.487 0-.65-.163-.162-.325-.162-.974 0-1.3l8.45-8.287h-6.174c-.488 0-.813-.325-.813-.813 0-.487.325-.812.813-.812h8.125z"
    />
  </SvgContainer>
);

const Share = () => (
  <SvgContainer>
    <path d="M13,6.16414207 L13,13 L11,13 L11,6.16414207 L8.5,8.25257669 L7.18299078,6.74742331 L11.3414954,3.24742331 C11.7185214,2.91752556 12.2814786,2.91752556 12.6585046,3.24742331 L16.8170092,6.74742331 L15.5,8.25257669 L13,6.16414207 Z M16,18 L16,11 L18,11 L18,19 C18,19.5522847 17.5522847,20 17,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,11 L8,11 L8,18 L16,18 Z" />
  </SvgContainer>
);

const Hint = () => (
  <SvgContainer>
    <path d="M22.8,12 C22.8,6.04041451 17.9595855,1.2 12,1.2 C6.04041451,1.2 1.2,6.04041451 1.2,12 C1.2,17.9595855 6.04041451,22.8 12,22.8 C17.9595855,22.8 22.8,17.9595855 22.8,12 Z M11.9440415,8.81036269 C11.6642487,8.78238342 11.384456,8.89430052 11.1606218,9.09015544 C10.9647668,9.28601036 10.92,9.56580311 10.92,9.84559585 L8.76,9.84559585 C8.76,8.92227979 8.83834197,8.02694301 9.50984456,7.38341969 C10.1813472,6.73989637 11.0766839,6.40414508 12.0279793,6.43212435 C13.7626943,6.51606218 15.1896373,7.94300518 15.2735751,9.67772021 C15.3295337,11.1326425 14.4901554,12.4756477 13.119171,13.0072539 C13.0911917,13.0352332 13.0352332,13.0911917 13.0352332,13.1751295 L13.0352332,14.16 L10.6569948,14.16 L10.6569948,13.1751295 C10.6569948,12.1119171 11.2725389,11.188601 12.2238342,10.8248705 C12.6435233,10.6569948 12.8953368,10.2373057 12.8673575,9.78963731 C12.8953368,9.28601036 12.4476684,8.83834197 11.9440415,8.81036269 Z M12,17.94 C11.2544156,17.94 10.65,17.3355844 10.65,16.59 C10.65,15.8444156 11.2544156,15.24 12,15.24 C12.7455844,15.24 13.35,15.8444156 13.35,16.59 C13.35,17.3355844 12.7455844,17.94 12,17.94 Z" />
  </SvgContainer>
);

const HintClose = () => (
  <SvgContainer>
    <path d="M10.4726494,12 L7.45632468,15.0163247 L8.98367532,16.5436753 L12,13.5273506 L15.0163247,16.5436753 L16.5436753,15.0163247 L13.5273506,12 L16.5436753,8.98367532 L15.0163247,7.45632468 L12,10.4726494 L8.98367532,7.45632468 L7.45632468,8.98367532 L10.4726494,12 Z M22.8,12 C22.8,17.9595855 17.9595855,22.8 12,22.8 C6.04041451,22.8 1.2,17.9595855 1.2,12 C1.2,6.04041451 6.04041451,1.2 12,1.2 C17.9595855,1.2 22.8,6.04041451 22.8,12 Z" />
  </SvgContainer>
);

const Search = (props) => (
  <SvgContainer {...props}>
    <path d="M11.8175479,11.6587719 L8.85934259,8.49034161 C9.61994914,7.55920374 10.03669,6.38764175 10.03669,5.16799494 C10.03669,2.31840747 7.78541677,0 5.01834498,0 C2.2512732,0 0,2.31840747 0,5.16799494 C0,8.01758242 2.2512732,10.3359899 5.01834498,10.3359899 C6.05714239,10.3359899 7.04706549,10.0133272 7.89342028,9.4008075 L10.874099,12.5932802 C10.9986849,12.7265246 11.166254,12.8 11.3458234,12.8 C11.5157926,12.8 11.6770342,12.7332655 11.7994382,12.6119299 C12.0595194,12.3542043 12.0678105,11.9268335 11.8175479,11.6587719 Z M5.01834498,1.34817259 C7.06364785,1.34817259 8.72755649,3.06169996 8.72755649,5.16799494 C8.72755649,7.27428993 7.06364785,8.98781729 5.01834498,8.98781729 C2.97304212,8.98781729 1.30913347,7.27428993 1.30913347,5.16799494 C1.30913347,3.06169996 2.97304212,1.34817259 5.01834498,1.34817259 Z" />
  </SvgContainer>
);

const Plus = () => (
  <SvgContainer>
    <path d="M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z" />
  </SvgContainer>
);

const Minus = () => (
  <SvgContainer>
    <path d="M0 6.5v3c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5z" />
  </SvgContainer>
);

const Close = () => (
  <SvgContainer>
    <path d="M8.23814388,7.00014593 L13.74347,1.49459026 C14.08551,1.15282787 14.08551,0.598303071 13.74347,0.256540683 C13.40143,-0.0855135608 12.847512,-0.0855135608 12.5054721,0.256540683 L7.00014592,5.76209635 L1.49452794,0.256540683 C1.15248796,-0.0855135608 0.598569969,-0.0855135608 0.256529987,0.256540683 C-0.0855099956,0.598303071 -0.0855099956,1.15282787 0.256529987,1.49459026 L5.76214796,7.00014593 L0.256529987,12.5057016 C-0.0855099956,12.847464 -0.0855099956,13.4019888 0.256529987,13.7437512 C0.427549978,13.9144864 0.651685393,14 0.875528965,14 C1.09937254,14 1.32350795,13.9144864 1.49452794,13.7434593 L7.00014592,8.23790365 L12.5054721,13.7434593 C12.676492,13.9144864 12.9006275,14 13.124471,14 C13.3483146,14 13.57245,13.9144864 13.74347,13.7434593 C14.08551,13.4016969 14.08551,12.8471721 13.74347,12.5054097 L8.23814388,7.00014593 Z" />
  </SvgContainer>
);

const Alert = (props) => (
  <SvgContainer {...props}>
    <path d="M7,0 C3.13425,0 0,3.13425 0,7 C0,10.86575 3.13425,14 7,14 C10.86575,14 14,10.86575 14,7 C14,3.13425 10.86575,0 7,0 Z M7,11.4683333 C6.45283333,11.4683333 6.07833333,11.0465833 6.07833333,10.5 C6.07833333,9.93766667 6.46858333,9.53166667 7,9.53166667 C7.56175,9.53166667 7.92166667,9.93766667 7.92166667,10.5 C7.92166667,11.0471667 7.56175,11.4683333 7,11.4683333 Z M7.36283333,7.77058333 C7.22341667,8.246 6.78416667,8.25416667 6.63775,7.77058333 C6.46916667,7.21291667 5.87008333,5.096 5.87008333,3.72108333 C5.87008333,1.90691667 8.13983333,1.89816667 8.13983333,3.72108333 C8.13925,5.10416667 7.50808333,7.27591667 7.36283333,7.77058333 Z" />
  </SvgContainer>
);

const Add = () => (
  <SvgContainer>
    <polygon points="13 11 18 11 18 13 13 13 13 18 11 18 11 13 6 13 6 11 11 11 11 6 13 6" />
  </SvgContainer>
);

const AddSmall = () => (
  <SvgContainer>
    <polygon points="13 11 17 11 17 13 13 13 13 17 11 17 11 13 7 13 7 11 11 11 11 7 13 7" />
  </SvgContainer>
);

const Remove = () => (
  <SvgContainer>
    <rect x="6" y="11" width="12" height="3" />
  </SvgContainer>
);

const ArrowUp = () => (
  <SvgContainer>
    <path d="M13,8.57080187 L13,19 L11,19 L11,8.57080187 L7.23715414,12.6757246 L5.76284586,11.3242754 L11.2628459,5.32427537 C11.6591824,4.89190821 12.3408176,4.89190821 12.7371541,5.32427537 L18.2371541,11.3242754 L16.7628459,12.6757246 L13,8.57080187 Z" />
  </SvgContainer>
);

const ArrowDown = () => (
  <SvgContainer>
    <path d="M11,16.4291981 L11,5.5 L13,5.5 L13,16.4291981 L16.7628459,12.3242754 L18.2371541,13.6757246 L12.7371541,19.6757246 C12.3408176,20.1080918 11.6591824,20.1080918 11.2628459,19.6757246 L5.76284586,13.6757246 L7.23715414,12.3242754 L11,16.4291981 Z" />
  </SvgContainer>
);

const ToggleArrow = () => (
  <SvgContainer>
    <path d="M9.431 7.257l1.352-1.474 5.893 5.48a1 1 0 0 1 0 1.474l-5.893 5.45-1.352-1.475L14.521 12 9.43 7.257z" />
  </SvgContainer>
);

const Trash = () => (
  <SvgContainer>
    <path
      d="M8,19 L16,19 L16,13 L8,13 L8,19 Z M16,7 L20,7 L20,9 L4,9 L4,7 L8,7 L8,3 L16,3 L16,7 Z M14,7 L14,5 L10,5 L10,7 L14,7 Z M6,11 L18,11 L18,21 L6,21 L6,11 Z"
      fillRule="nonzero"
    />
  </SvgContainer>
);

const Tick = () => (
  <SvgContainer>
    <path d="M16.6917162,8.75389189 L18.3082838,10.2461081 L12.3082838,16.7461081 C11.8845221,17.2051833 11.1639539,17.2195889 10.7221825,16.7778175 L6.22218254,12.2778175 L7.77781746,10.7221825 L11.4682653,14.4126304 L16.6917162,8.75389189 Z" />
  </SvgContainer>
);

const Chevron = (props) => (
  <SvgContainer {...props}>
    <path d="M9.32427537,7.23715414 L10.6757246,5.76284586 L16.6757246,11.2628459 C17.1080918,11.6591824 17.1080918,12.3408176 16.6757246,12.7371541 L10.6757246,18.2371541 L9.32427537,16.7628459 L14.5201072,12 L9.32427537,7.23715414 Z" />
  </SvgContainer>
);

const CloseIO = (props) => (
  <SvgContainer {...props}>
    <path d="M11.987107,10.5728934 L16.2800002,6.28000021 L17.6942138,7.69421377 L13.4013206,11.987107 L17.6942138,16.2800002 L16.2800002,17.6942138 L11.987107,13.4013206 L7.69421377,17.6942138 L6.28000021,16.2800002 L10.5728934,11.987107 L6.28000021,7.69421377 L7.69421377,6.28000021 L11.987107,10.5728934 Z" />
  </SvgContainer>
);

const CloseLarge = (props) => (
  <SvgContainer {...props}>
    <path d="M10.5857864,12 L3.79289322,5.20710678 L5.20710678,3.79289322 L12,10.5857864 L18.7928932,3.79289322 L20.2071068,5.20710678 L13.4142136,12 L20.2071068,18.7928932 L18.7928932,20.2071068 L12,13.4142136 L5.20710678,20.2071068 L3.79289322,18.7928932 L10.5857864,12 Z" />
  </SvgContainer>
);

const FullSize = () => (
  <SvgContainer>
    <path d="M8,17 L12,17 L12,19 L6,19 L6,13 L8,13 L8,17 Z M18,6 L18,12 L16,12 L16,8 L12,8 L12,6 L18,6 Z" />
  </SvgContainer>
);

const Settings = () => (
  <SvgContainer>
    <path d="M6,17 L6,15 L8,15 L8,17 L21,17 L21,19 L8,19 L8,21 L6,21 L6,19 L3,19 L3,17 L6,17 Z M16,11 L16,9 L18,9 L18,11 L21,11 L21,13 L18,13 L18,15 L16,15 L16,13 L3,13 L3,11 L16,11 Z M6,5 L6,3 L8,3 L8,5 L21,5 L21,7 L8,7 L8,9 L6,9 L6,7 L3,7 L3,5 L6,5 Z" />
  </SvgContainer>
);

const Bold = () => (
  <SvgContainer>
    <path d="M8,17 L8,7 L11.7707948,7 C13.0770244,7 14.0677723,7.23236947 14.7430684,7.69711538 C15.4183644,8.1618613 15.7560074,8.84294423 15.7560074,9.74038462 C15.7560074,10.2303138 15.6204573,10.6618571 15.349353,11.0350275 C15.0782488,11.4081978 14.7011731,11.6817757 14.2181146,11.8557692 C14.7701814,11.983975 15.205174,12.242672 15.5231054,12.6318681 C15.8410367,13.0210642 16,13.4972499 16,14.0604396 C16,15.0219828 15.6697507,15.7499975 15.0092421,16.2445055 C14.3487336,16.7390135 13.4072766,16.9908424 12.1848429,17 L8,17 Z M10.2181146,12.6456044 L10.2181146,15.3447802 L12.1182994,15.3447802 C12.6407913,15.3447802 13.0486738,15.2291678 13.3419593,14.9979396 C13.6352448,14.7667113 13.7818854,14.4473464 13.7818854,14.0398352 C13.7818854,13.1240797 13.2717241,12.6593407 12.2513863,12.6456044 L10.2181146,12.6456044 Z M10.2181146,11.1895604 L11.8595194,11.1895604 C12.9784406,11.1712453 13.5378928,10.7568722 13.5378928,9.94642857 C13.5378928,9.4931296 13.3961813,9.1668966 13.1127542,8.96771978 C12.829327,8.76854296 12.3820117,8.66895604 11.7707948,8.66895604 L10.2181146,8.66895604 L10.2181146,11.1895604 Z" />
  </SvgContainer>
);

const Italic = () => (
  <SvgContainer>
    <path d="M10.1737981,15.5714286 L11.5584135,8.42857143 L9.95714286,8.42857143 C9.7598983,8.42857143 9.6,8.26867312 9.6,8.07142857 L9.6,7.35714286 C9.6,7.1598983 9.7598983,7 9.95714286,7 L15.6428571,7 C15.8401017,7 16,7.1598983 16,7.35714286 L16,8.07142857 C16,8.26867312 15.8401017,8.42857143 15.6428571,8.42857143 L13.7330228,8.42857143 L12.3484075,15.5714286 L14.0428571,15.5714286 C14.2401017,15.5714286 14.4,15.7313269 14.4,15.9285714 L14.4,16.6428571 C14.4,16.8401017 14.2401017,17 14.0428571,17 L8.35714286,17 C8.1598983,17 8,16.8401017 8,16.6428571 L8,15.9285714 C8,15.7313269 8.1598983,15.5714286 8.35714286,15.5714286 L10.1737981,15.5714286 Z" />
  </SvgContainer>
);

const UnorderedList = () => (
  <SvgContainer>
    <path d="M9,6.7 L9,8.3 C9,8.41045695 9.08954305,8.5 9.2,8.5 L19.8,8.5 C19.9104569,8.5 20,8.41045695 20,8.3 L20,6.7 C20,6.58954305 19.9104569,6.5 19.8,6.5 L9.2,6.5 C9.08954305,6.5 9,6.58954305 9,6.7 Z M9.2,18.5 L19.8,18.5 C19.9104569,18.5 20,18.4104569 20,18.3 L20,16.7 C20,16.5895431 19.9104569,16.5 19.8,16.5 L9.2,16.5 C9.08954305,16.5 9,16.5895431 9,16.7 L9,18.3 C9,18.4104569 9.08954305,18.5 9.2,18.5 Z M9.2,13.5 C9.08954305,13.5 9,13.4104569 9,13.3 L9,11.7 C9,11.5895431 9.08954305,11.5 9.2,11.5 L19.8,11.5 C19.9104569,11.5 20,11.5895431 20,11.7 L20,13.3 C20,13.4104569 19.9104569,13.5 19.8,13.5 L9.2,13.5 Z M5.5,9 C4.67157288,9 4,8.32842712 4,7.5 C4,6.67157288 4.67157288,6 5.5,6 C6.32842712,6 7,6.67157288 7,7.5 C7,8.32842712 6.32842712,9 5.5,9 Z M5.5,14 C4.67157288,14 4,13.3284271 4,12.5 C4,11.6715729 4.67157288,11 5.5,11 C6.32842712,11 7,11.6715729 7,12.5 C7,13.3284271 6.32842712,14 5.5,14 Z M5.5,19 C4.67157288,19 4,18.3284271 4,17.5 C4,16.6715729 4.67157288,16 5.5,16 C6.32842712,16 7,16.6715729 7,17.5 C7,18.3284271 6.32842712,19 5.5,19 Z" />
  </SvgContainer>
);

const OrderedList = () => (
  <SvgContainer>
    <path d="M9,6.2 L9,7.8 C9,7.91045695 9.08954305,8 9.2,8 L19.8,8 C19.9104569,8 20,7.91045695 20,7.8 L20,6.2 C20,6.08954305 19.9104569,6 19.8,6 L9.2,6 C9.08954305,6 9,6.08954305 9,6.2 Z M9.2,18 L19.8,18 C19.9104569,18 20,17.9104569 20,17.8 L20,16.2 C20,16.0895431 19.9104569,16 19.8,16 L9.2,16 C9.08954305,16 9,16.0895431 9,16.2 L9,17.8 C9,17.9104569 9.08954305,18 9.2,18 Z M9.2,13 C9.08954305,13 9,12.9104569 9,12.8 L9,11.2 C9,11.0895431 9.08954305,11 9.2,11 L19.8,11 C19.9104569,11 20,11.0895431 20,11.2 L20,12.8 C20,12.9104569 19.9104569,13 19.8,13 L9.2,13 Z M4,16 L4,15 L7,15 L7,19 L4,19 L4,18 L6,18 L6,17.5 L5,17.5 L5,16.5 L6,16.5 L6,16 L4,16 Z M5,9 L5,6 L4,6 L4,5 L6,5 L6,9 L5,9 Z M4,11 L4,10 L7,10 L7,10.9 L5.2,13 L7,13 L7,14 L4,14 L4,13.1 L5.8,11 L4,11 Z" />
  </SvgContainer>
);

const Strike = () => (
  <SvgContainer>
    <path d="M8.218776,10.6611638 C7.9938233,10.2394416 7.88134766,9.77395634 7.88134766,9.26470588 C7.88134766,8.63368668 8.0527191,8.07085809 8.39546712,7.57620321 C8.73821515,7.08154833 9.23042485,6.69518856 9.872111,6.4171123 C10.5137972,6.13903604 11.2340726,6 12.032959,6 C12.8369995,6 13.5534094,6.15106801 14.1822103,6.45320856 C14.8110112,6.7553491 15.2993554,7.18181543 15.6472575,7.73262032 C15.9951596,8.28342521 16.1691081,8.90908741 16.1691081,9.60962567 L13.8497721,9.60962567 C13.8497721,9.07486364 13.6874202,8.65909239 13.3627116,8.36229947 C13.0380029,8.06550654 12.5818714,7.9171123 11.9943034,7.9171123 C11.4273518,7.9171123 10.9866823,8.04144261 10.6722819,8.29010695 C10.3578815,8.5387713 10.2006836,8.86630813 10.2006836,9.27272727 C10.2006836,9.65240832 10.3849401,9.97058695 10.7534587,10.2272727 C10.9695179,10.3777654 11.2453678,10.5227422 11.5810116,10.6622047 C10.7381999,10.6611638 9.35727946,10.6622047 8.218776,10.6611638 Z M13.842041,14.7754011 C13.842041,14.3208533 13.6874202,13.9719264 13.3781738,13.7286096 C13.2203718,13.6044501 12.9981534,13.4768105 12.7115165,13.3456897 C12.9823481,13.3439472 15.4837341,13.3456897 15.8720434,13.3439472 C16.0700871,13.7665751 16.1691081,14.2383774 16.1691081,14.7593583 C16.1691081,15.7700585 15.800595,16.5628314 15.0635579,17.1377005 C14.3265208,17.7125697 13.3343704,18 12.0870768,18 C11.2211871,18 10.4326207,17.8355631 9.72135417,17.5066845 C9.01008759,17.1778058 8.46762611,16.7272756 8.09395345,16.1550802 C7.72028079,15.5828848 7.53344727,14.9197899 7.53344727,14.1657754 L9.86051432,14.1657754 C9.86051432,15.4545519 10.6026944,16.0989305 12.0870768,16.0989305 C12.6385661,16.0989305 13.0689275,15.9826215 13.3781738,15.75 C13.6874202,15.5173785 13.842041,15.1925155 13.842041,14.7754011 Z M7.43231072,11.3549113 L16.5676893,11.3549113 C16.8064479,11.3549113 17,11.5484634 17,11.7872221 L17,12.2195328 C17,12.4582914 16.8064479,12.6518435 16.5676893,12.6518435 L7.43231072,12.6518435 C7.1935521,12.6518435 7,12.4582914 7,12.2195328 L7,11.7872221 C7,11.5484634 7.1935521,11.3549113 7.43231072,11.3549113 Z" />
  </SvgContainer>
);

const Underline = () => (
  <SvgContainer>
    <path d="M16.3453125,7 L16.3453125,13.402819 C16.3453125,14.4666225 15.951127,15.3078604 15.1627441,15.9265579 C14.3743613,16.5452553 13.2972725,16.8545994 11.9314453,16.8545994 C10.586712,16.8545994 9.51885161,16.5541573 8.72783203,15.9532641 C7.93681245,15.3523709 7.53339852,14.5267115 7.51757812,13.4762611 L7.51757812,7 L9.890625,7 L9.890625,13.4161721 C9.890625,14.0526738 10.0712384,14.5166899 10.4324707,14.8082344 C10.793703,15.0997789 11.2933562,15.245549 11.9314453,15.245549 C13.2656317,15.245549 13.9432616,14.6535668 13.9643555,13.4695846 L13.9643555,7 L16.3453125,7 Z M7.87982196,17.4807122 L16.120178,17.4807122 C16.3299479,17.4807122 16.5,17.6507642 16.5,17.8605341 L16.5,18.620178 C16.5,18.8299479 16.3299479,19 16.120178,19 L7.87982196,19 C7.67005208,19 7.5,18.8299479 7.5,18.620178 L7.5,17.8605341 C7.5,17.6507642 7.67005208,17.4807122 7.87982196,17.4807122 Z" />
  </SvgContainer>
);

const Link = () => (
  <SvgContainer>
    <path d="M16.2130943,7.78690569 C15.2823632,6.85617459 13.77335,6.85617459 12.8426189,7.78690569 L7.78690569,12.8426189 C6.85617459,13.77335 6.85617459,15.2823632 7.78690569,16.2130943 C8.71763678,17.1438254 10.22665,17.1438254 11.1573811,16.2130943 L16.2130943,11.1573811 C17.1438254,10.22665 17.1438254,8.71763678 16.2130943,7.78690569 Z M13.943728,15.6737311 L12.280873,17.3365861 C10.7296545,18.8878046 8.21463236,18.8878046 6.66341387,17.3365861 C5.11219538,15.7853676 5.11219538,13.2703455 6.66341387,11.719127 L8.32626889,10.056272 L9.45091165,11.1809148 L11.1361494,9.49567706 L10.0115066,8.3710343 L11.719127,6.66341387 C13.2703455,5.11219538 15.7853676,5.11219538 17.3365861,6.66341387 C18.8878046,8.21463236 18.8878046,10.7296545 17.3365861,12.280873 L15.6289657,13.9884934 L15.6301166,13.9896443 L13.9448789,15.6748821 L13.943728,15.6737311 Z M13.943728,15.6737311 L15.6289657,13.9884934 L14.5054739,12.8650016 L12.8202362,14.5502393 L13.943728,15.6737311 Z M13.9658723,10.0344648 C13.6556286,9.72422109 13.1526242,9.72422109 12.8423805,10.0344648 L10.033651,12.8431943 C9.72340725,13.153438 9.72340725,13.6564425 10.033651,13.9666862 C10.3438947,14.2769299 10.8468991,14.2769299 11.1571428,13.9666862 L13.9658723,11.1579566 C14.276116,10.8477129 14.276116,10.3447085 13.9658723,10.0344648 Z" />
  </SvgContainer>
);

const LinkDisabled = () => (
  <SvgContainer>
    <path d="M11.7289758,8.90054871 L10.605484,7.7770569 L11.719127,6.66341387 C13.2703455,5.11219538 15.7853676,5.11219538 17.3365861,6.66341387 C18.8878046,8.21463236 18.8878046,10.7296545 17.3365861,12.280873 L16.2229431,13.394516 L15.0994513,12.2710242 L16.2130943,11.1573811 C17.1438254,10.22665 17.1438254,8.71763678 16.2130943,7.78690569 C15.2823632,6.85617459 13.77335,6.85617459 12.8426189,7.78690569 L11.7289758,8.90054871 Z M8.90054871,11.7289758 L7.78690569,12.8426189 C6.85617459,13.77335 6.85617459,15.2823632 7.78690569,16.2130943 C8.71763678,17.1438254 10.22665,17.1438254 11.1573811,16.2130943 L12.2710242,15.0994513 L13.394516,16.2229431 L12.280873,17.3365861 C10.7296545,18.8878046 8.21463236,18.8878046 6.66341387,17.3365861 C5.11219538,15.7853676 5.11219538,13.2703455 6.66341387,11.719127 L7.7770569,10.605484 L8.90054871,11.7289758 Z M13.9760363,11.1476092 L12.8527279,10.0243008 C13.1637094,9.72425892 13.6590544,9.72764691 13.9658723,10.0344648 C14.2726902,10.3412827 14.2760782,10.8366277 13.9760363,11.1476092 Z M11.1476231,13.9760503 C10.8366936,14.2768978 10.3407412,14.2737764 10.033651,13.9666862 C9.72656068,13.6595959 9.72343931,13.1636435 10.0242868,12.852714 L11.1476231,13.9760503 Z M6.43431458,7.56568542 L7.56568542,6.43431458 L17.5656854,16.4343146 L16.4343146,17.5656854 L6.43431458,7.56568542 Z" />
  </SvgContainer>
);

const RightArrow = () => (
  <SvgContainer>
    <path d="M8,3.57080187 L8,14 L6,14 L6,3.57080187 L2.23715414,7.6757246 L0.76284586,6.3242754 L6.2628459,0.32427537 C6.6591824,-0.10809179 7.3408176,-0.10809179 7.7371541,0.32427537 L13.2371541,6.3242754 L11.7628459,7.6757246 L8,3.57080187 Z" />
  </SvgContainer>
);

const LeftArrow = () => (
  <SvgContainer>
    <path d="M8,3.57080187 L8,14 L6,14 L6,3.57080187 L2.23715414,7.6757246 L0.76284586,6.3242754 L6.2628459,0.32427537 C6.6591824,-0.10809179 7.3408176,-0.10809179 7.7371541,0.32427537 L13.2371541,6.3242754 L11.7628459,7.6757246 L8,3.57080187 Z" />
  </SvgContainer>
);

const Duplicate = () => (
  <SvgContainer>
    <path d="M5 9h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1zm1 2v8h8v-8H6zm12-4H9V5h10a1 1 0 0 1 1 1v10h-2V7z" />
  </SvgContainer>
);

const Upload = (props) => (
  <SvgContainer {...props}>
    <path d="M8.035 11.97h2.435v6.023h4.06V11.97h2.435L12.5 6.537 8.035 11.97zm-1.919 2.008A1.11 1.11 0 0 1 5 12.874c0-.254.088-.5.25-.696l6.384-7.77a1.125 1.125 0 0 1 1.57-.16c.087.074.087.074.162.16l6.384 7.77a1.096 1.096 0 0 1-.162 1.553c-.2.16-.448.247-.704.247H16.56v4.918c0 .61-.5 1.104-1.117 1.104H9.557a1.11 1.11 0 0 1-1.117-1.104v-4.918H6.116z" />
  </SvgContainer>
);

const Download = () => (
  <SvgContainer>
    <path d="M9,6 L9,13 L7.20376823,13 L12,18.4814077 L16.7962318,13 L15,13 L15,6 L9,6 Z M7,11 L7,5 C7,4.44771525 7.44771525,4 8,4 L16,4 C16.5522847,4 17,4.44771525 17,5 L17,11 L19,11 C19.8591588,11 20.3183367,12.0119217 19.7525767,12.6585046 L12.7525767,20.6585046 C12.3541654,21.1138318 11.6458346,21.1138318 11.2474233,20.6585046 L4.24742331,12.6585046 C3.68166327,12.0119217 4.14084119,11 5,11 L7,11 Z" />
  </SvgContainer>
);

const Zoom = () => (
  <SvgContainer>
    <path d="M11.5,15.5 C13.709139,15.5 15.5,13.709139 15.5,11.5 C15.5,9.290861 13.709139,7.5 11.5,7.5 C9.290861,7.5 7.5,9.290861 7.5,11.5 C7.5,13.709139 9.290861,15.5 11.5,15.5 Z M16.4027819,14.9595737 L18.6821579,17.1305862 L17.2679443,18.5447998 L14.9935823,16.3785629 C14.0096341,17.084429 12.803348,17.5 11.5,17.5 C8.1862915,17.5 5.5,14.8137085 5.5,11.5 C5.5,8.1862915 8.1862915,5.5 11.5,5.5 C14.8137085,5.5 17.5,8.1862915 17.5,11.5 C17.5,12.7883707 17.093925,13.9818975 16.4027819,14.9595737 Z" />
  </SvgContainer>
);

const Edit = () => (
  <SvgContainer>
    <path d="M11.695 15.117l6.531-6.344L15.5 6l-6.625 6.296 2.82 2.82zM10.27 16.52l-2.828-2.829-.446.446v2.828h2.829l.445-.445zm2.122.707l-1.415 1.414a1 1 0 0 1-.63.29H6.116c-.612.047-1.132-.306-1.085-.917v-4.4a1 1 0 0 1 .29-.63l2.12-2.121.018.017 6.909-6.578a1.6 1.6 0 0 1 2.263 0l3.292 3.338a1.6 1.6 0 0 1 0 2.263l-7.531 7.324z" />
  </SvgContainer>
);

const Facebook = () => (
  <SvgContainer>
    <path
      fill="#3B5998"
      d="M9.73 6.486v2.478H8v3.03h1.73l.013 8.506h3.552l-.014-8.505h2.384s.223-1.453.331-3.042h-2.701V6.881c0-.31.387-.726.77-.726H16V3h-2.631c-3.728 0-3.64 3.033-3.64 3.486z"
    />
  </SvgContainer>
);

const Linkedin = () => (
  <SvgContainer>
    <path
      fill="#0077B5"
      d="M7.86 7.704V18.5H4.214V7.704H7.86zm.24-3.34c0 1.037-.792 1.867-2.063 1.867h-.023C4.791 6.23 4 5.4 4 4.365 4 3.306 4.815 2.5 6.061 2.5c1.247 0 2.015.806 2.038 1.865zM21 12.31v6.19h-3.644v-5.776c0-1.45-.527-2.44-1.846-2.44-1.007 0-1.606.667-1.87 1.311-.096.231-.12.553-.12.876V18.5H9.876s.048-9.783 0-10.796h3.644v1.53c.484-.735 1.35-1.783 3.285-1.783C19.202 7.45 21 8.994 21 12.31z"
    />
  </SvgContainer>
);

const Google = () => (
  <SvgContainer>
    <path
      fill="#DB4A39"
      d="M7.617 10.017v2.971s2.926-.005 4.121-.005c-.647 1.922-1.648 2.97-4.12 2.97A4.423 4.423 0 0 1 3.166 11.5a4.427 4.427 0 0 1 4.45-4.454c1.325 0 2.178.458 2.961 1.095.63-.62.577-.707 2.173-2.19A7.676 7.676 0 0 0 7.623 4C3.414 4 0 7.36 0 11.5 0 15.64 3.414 19 7.623 19c6.293 0 7.83-5.392 7.317-8.983H7.617zm13.963.903V8.5h-2.082v2.42H17v2.082h2.498V15.5h2.082v-2.498H24V10.92h-2.42z"
    />
  </SvgContainer>
);

const Twitter = () => (
  <SvgContainer>
    <path
      fill="#1DA1F2"
      d="M22 6.657a7.644 7.644 0 0 1-2.121.557 3.577 3.577 0 0 0 1.624-1.956c-.714.405-1.504.7-2.345.858A3.767 3.767 0 0 0 16.462 5c-2.04 0-3.693 1.582-3.693 3.534 0 .277.033.547.096.806-3.07-.148-5.79-1.555-7.612-3.693-.318.522-.5 1.129-.5 1.777 0 1.226.652 2.308 1.643 2.942a3.804 3.804 0 0 1-1.673-.443v.045c0 1.712 1.273 3.14 2.962 3.465a3.856 3.856 0 0 1-1.667.061c.47 1.404 1.833 2.426 3.45 2.454a7.623 7.623 0 0 1-4.587 1.513c-.298 0-.592-.016-.881-.049A10.795 10.795 0 0 0 9.66 19c6.793 0 10.508-5.386 10.508-10.056a9.82 9.82 0 0 0-.01-.457A7.332 7.332 0 0 0 22 6.657z"
    />
  </SvgContainer>
);

const Star = () => (
  <SvgContainer>
    <path
      fill="#FFBA19"
      d="M10 13.762l-3.754 2.169a.515.515 0 0 1-.695-.172.481.481 0 0 1-.058-.36l.96-4.144-3.28-2.803a.484.484 0 0 1-.047-.695.512.512 0 0 1 .334-.166L7.808 7.2l1.727-3.9a.512.512 0 0 1 .93 0l1.727 3.9 4.348.392a.497.497 0 0 1 .458.537.489.489 0 0 1-.17.324l-3.28 2.803.96 4.144a.493.493 0 0 1-.384.589.519.519 0 0 1-.37-.057L10 13.762z"
    />
  </SvgContainer>
);

const SearchIO = () => (
  <SvgContainer>
    <path
      d="M12.2698261,15.8318852 C15.0312499,15.8318852 17.2698261,13.5933089 17.2698261,10.8318852 C17.2698261,8.07046142 15.0312499,5.83188517 12.2698261,5.83188517 C9.50840238,5.83188517 7.26982613,8.07046142 7.26982613,10.8318852 C7.26982613,13.5933089 9.50840238,15.8318852 12.2698261,15.8318852 Z M11.2702413,17.7610557 C7.87774473,17.2760047 5.26982613,14.3585009 5.26982613,10.8318852 C5.26982613,6.96589192 8.40383288,3.83188517 12.2698261,3.83188517 C16.1358194,3.83188517 19.2698261,6.96589192 19.2698261,10.8318852 C19.2698261,14.3582132 16.662333,17.2755287 13.2702412,17.7609369 L13.2720045,21.7077671 L11.2720045,21.7077671 L11.2702413,17.7610557 Z"
      transform="rotate(-45 12.27 12.77)"
    />
  </SvgContainer>
);

const Company = () => (
  <SvgContainer>
    <path d="M10.8,12 L10.8,4.8 L20.4,4.8 L20.4,19.2 L4.8,19.2 L4.8,12 L10.8,12 Z M13.2,7.2 L13.2,9.6 L18,9.6 L18,7.2 L13.2,7.2 Z M13.2,10.8 L13.2,13.2 L18,13.2 L18,10.8 L13.2,10.8 Z M13.2,14.4 L13.2,16.8 L18,16.8 L18,14.4 L13.2,14.4 Z M7.2,14.4 L7.2,16.8 L10.8,16.8 L10.8,14.4 L7.2,14.4 Z" />
  </SvgContainer>
);

const Calendar = (props) => (
  <SvgContainer {...props}>
    <path d="M15.6,6 L19.2,6 L19.2,19.2 L4.8,19.2 L4.8,6 L8.4,6 L8.4,4.2 L10.8,4.2 L10.8,6 L13.2,6 L13.2,4.2 L15.6,4.2 L15.6,6 Z M7.2,9.6 L7.2,16.8 L16.8,16.8 L16.8,9.6 L7.2,9.6 Z M8.4,14.4 L8.4,12 L10.8,12 L10.8,14.4 L8.4,14.4 Z M13.2,14.4 L13.2,12 L15.6,12 L15.6,14.4 L13.2,14.4 Z" />
  </SvgContainer>
);

const Location = () => (
  <SvgContainer>
    <path d="M7.92325987,15.4023311 C6.74039163,14.3064252 6,12.7396764 6,11 C6,7.6862915 8.6862915,5 12,5 C15.3137085,5 18,7.6862915 18,11 C18,12.7155806 17.2799763,14.2629907 16.1256355,15.3565236 L12.3183103,20.1101916 C12.2999388,20.1331295 12.2790953,20.153973 12.2561573,20.1723445 C12.0837303,20.3104455 11.8319976,20.2826186 11.6938967,20.1101916 L7.92325987,15.4023311 Z M12,14 C13.6568542,14 15,12.6568542 15,11 C15,9.34314575 13.6568542,8 12,8 C10.3431458,8 9,9.34314575 9,11 C9,12.6568542 10.3431458,14 12,14 Z" />
  </SvgContainer>
);

const Filter = () => (
  <SvgContainer>
    <path d="M11.8000058,11.4 C11.9298279,11.5730962 12.0000058,11.7836298 12.0000058,12 L12.0000058,15.382 L13.0000058,14.882 L13.0000058,12 C13.0000058,11.7836298 13.0701836,11.5730962 13.2000058,11.4 L17.0000058,6 L8.00000576,6 L11.8000058,11.4 Z M5.20000576,5.6 C4.97274253,5.29698235 4.93618656,4.89157043 5.10557857,4.5527864 C5.27497059,4.21400238 5.6212337,4 6.00000576,4 L19.0000058,4 C19.3787778,4 19.7250409,4.21400238 19.894433,4.5527864 C20.063825,4.89157043 20.027269,5.29698235 19.8000058,5.6 L15.0000058,12.333 L15.0000058,15.5 C14.9998035,15.8786657 14.7857352,16.2247365 14.4470058,16.394 L11.4470058,17.894 C11.1371033,18.0488588 10.7691266,18.0322854 10.4744001,17.8501945 C10.1796736,17.6681037 10.0001907,17.3464401 10.0000058,17 L10.0000058,12.333 L5.20000576,5.6 Z" />
  </SvgContainer>
);

const Gift = () => (
  <SvgContainer>
    <path d="M13 14v5h-2v-5H7v5h10v-5h-4zm0-2h5v-2H6v2h5v-2h2v2zm4.965-4H19a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h1.035A3.5 3.5 0 0 1 12 5.05 3.5 3.5 0 0 1 17.965 8zm-4.88 0h2.83a1.5 1.5 0 1 0-2.83 0zm-5 0h2.83a1.5 1.5 0 1 0-2.83 0z" />
  </SvgContainer>
);

const Burger = () => (
  <SvgContainer>
    <path d="M1 4h22v3H1V4zm0 7h22v3H1v-3zm0 7h22v3H1v-3z" />
  </SvgContainer>
);

const BurgerClose = () => (
  <SvgContainer>
    <path d="M12 9.879l6.718-6.718 2.121 2.121L14.121 12l6.718 6.718-2.121 2.121L12 14.121l-6.718 6.718-2.121-2.121L9.879 12 3.161 5.282l2.121-2.121z" />
  </SvgContainer>
);

const Lock = () => (
  <SvgContainer>
    <path d="M8,11 C8,7.83333333 9.375,6 12,6 C14.625,6 16,7.83333333 16,11 C16.5522847,11 17,11.4477153 17,12 L17,17 C17,17.5522847 16.5522847,18 16,18 L8,18 C7.44771525,18 7,17.5522847 7,17 L7,12 C7,11.4477153 7.44771525,11 8,11 Z M10,11 L14,11 C14,8.83333333 13.375,8 12,8 C10.625,8 10,8.83333333 10,11 Z" />
  </SvgContainer>
);

const Export = () => (
  <SvgContainer>
    <path d="M6,4 L14.9793444,4 C15.3056582,4 15.6114477,4.15921098 15.7985764,4.42653766 L18.8192319,8.74175989 C18.9368904,8.90984342 19,9.11005013 19,9.31522223 L19,20 C19,20.5522847 18.5522847,21 18,21 L6,21 C5.44771525,21 5,20.5522847 5,20 L5,5 C5,4.44771525 5.44771525,4 6,4 Z M7,6 L7,19 L17,19 L17,9.63044446 L14.4586889,6 L7,6 Z M9,11 L15,11 L15,13 L9,13 L9,11 Z M9,14 L15,14 L15,16 L9,16 L9,14 Z" />
  </SvgContainer>
);

const Spinner = (props) => (
  <SvgContainer {...props}>
    <path d="M17,12 C17,9.23857625 14.7614237,7 12,7 C9.23857625,7 7,9.23857625 7,12 C7,14.7614237 9.23857625,17 12,17 C12.5522847,17 13,17.4477153 13,18 C13,18.5522847 12.5522847,19 12,19 C8.13400675,19 5,15.8659932 5,12 C5,8.13400675 8.13400675,5 12,5 C15.8659932,5 19,8.13400675 19,12 C19,12.5522847 18.5522847,13 18,13 C17.4477153,13 17,12.5522847 17,12 Z" />
  </SvgContainer>
);

const ImageSmall = (props) => (
  <SvgContainer {...props}>
    <path d="M7 7h10v10H7V7zm5 3l-3 4h6l-3-4z" />
  </SvgContainer>
);

const ImageLarge = (props) => (
  <SvgContainer {...props}>
    <path d="M15 16h4l-4.5-8-3.192 4.643L9.5 11 5 16h10zM2 2h20v20H2V2z" />
  </SvgContainer>
);

const HintOutlined = (props) => (
  <SvgContainer {...props}>
    <path d="M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-1.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5zm3.69-13.47c0 2.73-2.827 2.73-2.827 5.558H10.62c0-3.608 2.73-3.608 2.73-5.363 0-.877-.585-1.462-1.56-1.462-.877 0-1.56.682-1.56 1.852H7.89c.098-2.438 1.657-3.998 3.9-3.998 2.438 0 3.9 1.463 3.9 3.413zm-5.167 7.8a1.29 1.29 0 0 1 1.267-1.267 1.29 1.29 0 0 1 1.268 1.267 1.29 1.29 0 0 1-1.268 1.268 1.29 1.29 0 0 1-1.267-1.268z" />
  </SvgContainer>
);

const Invisible = () => (
  <SvgContainer>
    <path d="M4.617 15.365c-.398-.5-.753-1.04-1.056-1.614-.107-.2-.238-.486-.396-.856a1 1 0 0 1 .002-.789c.208-.48.383-.845.524-1.096C5.38 8.01 8.467 6 12 6c1.5 0 2.92.362 4.187 1.01L13.899 8.66A3.89 3.89 0 0 0 12 8.167c-2.258 0-4.09 1.941-4.09 4.333 0 .159.007.316.023.47l-3.316 2.395zm3.196 2.626l2.288-1.652a3.89 3.89 0 0 0 1.899.494c2.258 0 4.09-1.941 4.09-4.333 0-.159-.007-.316-.023-.47l3.316-2.395c.324.406.62.84.881 1.296.154.267.342.658.567 1.173a1 1 0 0 1 .003.793c-.169.394-.31.696-.423.908C18.747 16.907 15.605 19 12 19c-1.5 0-2.92-.362-4.187-1.01zm4.362-8.085l-2.52 1.82C9.965 10.666 10.896 9.9 12 9.9c.059 0 .117.002.175.006zm2.17 3.368c-.31 1.06-1.241 1.826-2.345 1.826-.059 0-.117-.002-.175-.006l2.52-1.82zM3.585 19.81l-1.17-1.622 18-13 1.17 1.622-18 13z" />
  </SvgContainer>
);

const Idea = (props) => (
  <SvgContainer {...props}>
    <path d="M8.215 14.655a6 6 0 1 1 7.571 0C15.261 15.332 15 16.114 15 17H9c0-.886-.262-1.668-.785-2.345zM9.5 18h5a.5.5 0 1 1 0 1h-5a.5.5 0 1 1 0-1zm1 2h3a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1zM12 7.5a2.5 2.5 0 1 1 0 5V14a4 4 0 1 0 0-8v1.5z" />
  </SvgContainer>
);

const More = (props) => (
  <SvgContainer {...props}>
    <path d="M2.4 3.5C1.6 3.5.9 2.9.9 2S1.6.5 2.4.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm6 0c-.8 0-1.5-.6-1.5-1.5S7.6.5 8.4.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm6 0c-.8 0-1.5-.7-1.5-1.5S13.6.5 14.4.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5z" />
  </SvgContainer>
);

const MoreVertical = () => (
  <SvgContainer viewBox="0 0 6.7 22.1">
    <path d="M5.3 19.4c0 1.1-.9 1.9-1.9 1.9s-1.9-.9-1.9-1.9c0-1.1.9-1.9 1.9-1.9s1.9.9 1.9 1.9zm0-7.7c0 1.1-.9 1.9-1.9 1.9s-1.9-.9-1.9-1.9.9-1.9 1.9-1.9 1.9.8 1.9 1.9zm0-7.8c0 1.1-.9 1.9-1.9 1.9s-2-.8-2-1.9S2.3 2 3.3 2s2 .9 2 1.9z" />
  </SvgContainer>
);

const Pin = () => (
  <SvgContainer>
    <path d="M7.92379076,13.4025745 C6.11677148,11.7294165 5.51563898,9.1219685 6.40772455,6.82654707 C7.29981013,4.53112565 9.5039407,3.01390648 11.9665786,3.00009505 C14.4292165,2.98628362 16.6502262,4.47868488 17.5680021,6.7639559 C18.485778,9.04922692 17.9139295,11.6632535 16.1257908,13.3565745 L12.3187908,18.1105745 C12.2428721,18.205203 12.1281094,18.2602627 12.0067908,18.2602627 C11.8854721,18.2602627 11.7707095,18.205203 11.6947908,18.1105745 L7.92479076,13.4025745 L7.92379076,13.4025745 Z M12,12 C13.0717968,12 14.0621779,11.4282033 14.5980763,10.5 C15.1339747,9.57179678 15.1339747,8.42820322 14.5980763,7.49999998 C14.0621779,6.57179674 13.0717968,5.99999998 12,6 C10.3431458,6 9,7.34314575 9,9 C9,10.6568542 10.3431458,12 12,12 Z" />
  </SvgContainer>
);

const Bag = () => (
  <SvgContainer>
    <path d="M4.01470461,16.8420411 L4.01470461,8.66856283 C3.91571585,7.88952094 4.31650779,7.5 5.21708044,7.5 C6.11765308,7.5 7.2385336,7.5 8.57972199,7.5 L8.57972199,5.63333333 C8.66429615,4.54444444 9.42156837,4 10.8515386,4 C11.4895067,4 12.247873,4 13.1382211,4 C14.5894015,4 15.3539574,4.54444444 15.4318888,5.63333333 L15.4318888,7.5 C17.0529266,7.5 18.2195379,7.5 18.9317228,7.5 C19.6439076,7.5 20,7.88952094 20,8.66856283 L20,16.8420411 C20,17.6140137 19.6439076,18 18.9317228,18 C18.2500168,18 6.31912268,18 5.21708044,18 C4.41549655,18 4.01470461,17.6140137 4.01470461,16.8420411 Z M10.22,6 L10.22,7.5 L13.82,7.5 L13.8173374,6 L10.22,6 Z" />
  </SvgContainer>
);

const BackMobile = (props) => (
  <SvgContainer {...props}>
    <path d="M19.7275999,6.18828575 L13.7759385,0.270781305 C13.4128128,-0.0902604349 12.8238959,-0.0902604349 12.4607702,0.270781305 C12.09757,0.631897013 12.09757,1.21728614 12.4607702,1.57840185 L16.8249003,5.91748595 L0.929947086,5.91748595 C0.416393107,5.91748595 0,6.33148935 0,6.84209602 C0,7.35262871 0.416393107,7.76670609 0.929947086,7.76670609 L16.8249003,7.76670609 L12.460919,12.1057902 C12.0977188,12.4669059 12.0977188,13.052295 12.460919,13.4134107 C12.6424446,13.5938206 12.8805111,13.6842105 13.1185032,13.6842105 C13.3564952,13.6842105 13.5944873,13.5938206 13.7760873,13.4134107 L19.7275999,7.49590629 C20.0908,7.13479058 20.0908,6.54940145 19.7275999,6.18828575 Z" />
  </SvgContainer>
);

const Check = (props) => (
  <SvgContainer {...props}>
    <path d="M9,0 C4.00909091,0 0,4.00909091 0,9 C0,13.9909091 4.00909091,18 9,18 C13.9909091,18 18,13.9909091 18,9 C18,4.00909091 13.9909091,0 9,0 Z M14.1954545,6.17727273 L14.1954545,6.17727273 L7.65,12.9681818 C7.56818182,13.05 7.48636364,13.0909091 7.36363636,13.0909091 C7.24090909,13.0909091 7.11818182,13.05 7.07727273,12.9681818 L3.88636364,9.53181818 L3.80454545,9.45 C3.72272727,9.36818182 3.68181818,9.24545455 3.68181818,9.16363636 C3.68181818,9.08181818 3.72272727,8.95909091 3.80454545,8.87727273 L4.37727273,8.30454545 C4.54090909,8.14090909 4.78636364,8.14090909 4.95,8.30454545 L4.99090909,8.34545455 L7.24090909,10.7590909 C7.32272727,10.8409091 7.44545455,10.8409091 7.52727273,10.7590909 L13.0090909,5.07272727 L13.05,5.07272727 C13.2136364,4.90909091 13.4590909,4.90909091 13.6227273,5.07272727 L14.1954545,5.64545455 C14.3590909,5.76818182 14.3590909,6.01363636 14.1954545,6.17727273 L14.1954545,6.17727273 Z" />
  </SvgContainer>
);

const UpdatePhoto = (props) => (
  <SvgContainer {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.414 1L21 6.586V21c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h10.414zM13 3H5v18h14V9h-4c-1.105 0-2-.895-2-2V3zm-1 6.586l3.707 3.707-1.414 1.414L13 13.414V18h-2v-4.586l-1.293 1.293-1.414-1.414L12 9.586zm3-6.171V7h3.586L15 3.415z"
    />
  </SvgContainer>
);

const SliderIconSmall = (props) => (
  <SvgContainer width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.333 1.333c.737 0 1.334.597 1.334 1.334v10.666c0 .737-.597 1.334-1.334 1.334H2.667c-.737 0-1.334-.597-1.334-1.334V2.667c0-.737.597-1.334 1.334-1.334h10.666zm-8 8.276l-2.667 2.667v1.057h6.39L5.333 9.61zm6.667-2L8.61 11l2.332 2.334h2.391v-4.39L12 7.608zm1.333-4.942H2.667v7.723l2.666-2.666 2.333 2.332L12 5.724l1.333 1.332v-4.39zm-6 .666c1.105 0 2 .896 2 2 0 1.105-.895 2-2 2-1.104 0-2-.895-2-2 0-1.104.896-2 2-2zm0 1.334c-.368 0-.666.298-.666.666 0 .369.298.667.666.667C7.702 6 8 5.702 8 5.333c0-.368-.298-.666-.667-.666z"
    />
  </SvgContainer>
);

const SliderIconBig = (props) => (
  <SvgContainer {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.333 1.333c.737 0 1.334.597 1.334 1.334v10.666c0 .737-.597 1.334-1.334 1.334H2.667c-.737 0-1.334-.597-1.334-1.334V2.667c0-.737.597-1.334 1.334-1.334h10.666zm-8 8.276l-2.667 2.667v1.057h6.39L5.333 9.61zm6.667-2L8.61 11l2.332 2.334h2.391v-4.39L12 7.608zm1.333-4.942H2.667v7.723l2.666-2.666 2.333 2.332L12 5.724l1.333 1.332v-4.39zm-6 .666c1.105 0 2 .896 2 2 0 1.105-.895 2-2 2-1.104 0-2-.895-2-2 0-1.104.896-2 2-2zm0 1.334c-.368 0-.666.298-.666.666 0 .369.298.667.666.667C7.702 6 8 5.702 8 5.333c0-.368-.298-.666-.667-.666z"
    />
  </SvgContainer>
);

const SpellCheck = (props) => (
  <SvgContainer {...props}>
    <g stroke="null" fillRule="evenodd">
      <path d="M16.808 21.945c2.483 0 4.496-2.125 4.496-4.746 0-2.622-2.013-4.747-4.496-4.747-2.483 0-4.497 2.125-4.497 4.747 0 2.621 2.014 4.746 4.497 4.746zm-3.06-5.043l1.249-1.253 1.405 1.45 2.248-2.405 1.218 1.285-3.466 3.725-2.654-2.802zM14.149 12.673c-.654.37-1.19.884-1.546 1.49H6.395l-1.44 3.457h-2.08L8.717 4.375h1.765l3.667 8.298zm-1.943.053H7.004L9.6 6.53l2.606 6.195z" />
    </g>
  </SvgContainer>
);

const Rotate = (props) => (
  <SvgContainer {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.807 7C16.447 5.079 14.394 4 12 4c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8h2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2c2.804 0 5.275 1.183 7 3.27V2h2v7h-7V7h3.807z"
    />
  </SvgContainer>
);

const CirclePlus = (props) => (
  <SvgContainer {...props} viewBox="0 0 16 16">
    <path d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 2a6 6 0 100 12A6 6 0 008 2zm1 2v3h3v2H9v3H7V9H4V7h3V4h2z" />
  </SvgContainer>
);
const CircleCross = (props) => (
  <SvgContainer {...props} viewBox="0 0 16 16">
    <path d="M11 9V6H9L9 9H6V11H9L9 14H11V11H14V9H11Z" fill="currentColor" />
  </SvgContainer>
);

export default {
  FullSizeLarge,
  Share,
  Hint,
  HintClose,
  Search,
  Plus,
  Minus,
  Close,
  Alert,
  Add,
  Remove,
  ArrowUp,
  ArrowDown,
  ToggleArrow,
  Trash,
  Tick,
  Chevron,
  CloseIO,
  CloseLarge,
  FullSize,
  Settings,
  Bold,
  Italic,
  Underline,
  Strike,
  UnorderedList,
  OrderedList,
  Link,
  LinkDisabled,
  RightArrow,
  LeftArrow,
  AddSmall,
  Duplicate,
  Upload,
  Download,
  Zoom,
  Edit,
  Facebook,
  Linkedin,
  Google,
  Twitter,
  Star,
  SearchIO,
  Company,
  Calendar,
  Location,
  Filter,
  Gift,
  Burger,
  BurgerClose,
  Lock,
  Export,
  Spinner,
  ImageSmall,
  ImageLarge,
  HintOutlined,
  Invisible,
  Idea,
  More,
  MoreVertical,
  Pin,
  Bag,
  BackMobile,
  Check,
  UpdatePhoto,
  SliderIconSmall,
  SliderIconBig,
  SpellCheck,
  Rotate,
  CloseDark,
  CirclePlus,
  CircleCross,
  Article,
  DropdownSearch,
};
